import React from 'react';
import Image from 'next/image'
import PageTransition from '@/components/page-transition/PageTransition';
import classes from './purpose.module.scss';
import Text from '@/components/text/text';
import Hero from '@/components/hero/hero';
import SplitContent from '@/components/split_content/split_content';
import Tennis from '@/assets/images/tennis.webp';
import ContentArea from '@/components/content-area/content-area';
import Contact from '@/components/contact/contact';
import StructuredData from './structured-data';
import Link from 'next/link';

type PurposePageProps = {}
type PurposePageRef = React.ForwardedRef<HTMLDivElement>

export default function Purpose(props: PurposePageProps, ref: PurposePageRef) {

  return (
    <>
      <StructuredData />
      <PageTransition>
        <main className={classes.wrapper}>
          <div className={'body-bg'}></div>

          <Hero
            title='Our purpose'
          />

          <ContentArea hero>
              <>
              <SplitContent>
                <>
                <Text type={'h5'} padding={'large'} column={0}  >We help you to understand and implement data-driven sports digital marketing strategies to maximise your return on investment.</Text>
                
                </>
              </SplitContent>
              </>
            </ContentArea>

            <ContentArea hero>
              <>
              <Text type={'h2'} column={0} size='medium' >Data-Led Performance Strategies</Text>
              <SplitContent>
                <>
                <Text type={'h5'} padding={'large'} column={0}>We believe in the power of data-driven decision-making. </Text>
                <div>
                  <Text type={'p'} column={0}>By utilising advanced <Link scroll={false} href="/data">analytics</Link> and insights, we help you uncover valuable information about your target audience, their preferences, and behaviours.</Text>
                  <Text type={'p'} column={0}>This enables us to create targeted campaigns and strategies that drive results and deliver a strong return on investment.</Text>
                  <Text type={'p'} column={0}>At eighteen yards, we specialise in delivering bespoke <Link scroll={false} href="/performance">performance marketing strategies</Link> tailored specifically to your business objectives.</Text>
                </div>
                </>
              </SplitContent>
              </>
            </ContentArea>

            <ContentArea>
              <>
              <Text type={'h2'} column={0} size='medium' >End-to-end performance</Text>
              <SplitContent>
                <>
                <Text type={'h5'} padding={'large'} column={0} >Our range of services covers all aspects of digital marketing, ensuring a holistic approach that addresses your specific needs.</Text>
                <div>
                  <Text type={'p'} column={0} >From crafting <Link scroll={false} href="/performance">performance marketing</Link> strategies that align with your goals to <Link scroll={false} href="/training">training</Link> your team in boosting organic search rankings, we have the tools and techniques to elevate your online presence.</Text>
                  <Image className={classes['content-image']} alt="tennis" src={Tennis} width="600" height="600" />
                </div>
                </>
              </SplitContent>
              </>
            </ContentArea>

            <ContentArea>
              <>
              <Text type={'h2'} column={0} size='medium'>Working with <span style={{display: 'block'}}>eighteen yards</span></Text>
              <SplitContent>
                <>
                <div></div>
                <div>
                  <Text type={'p'} column={0} >We work closely with you, understanding your unique business objectives and challenges, to develop <Link scroll={false} href="/strategy">strategies</Link> that align with your vision.</Text>
                  <Text type={'p'} column={0} >Our team provides regular reports and analysis, keeping you informed about your campaigns and allowing for data-driven optimisations.We work closely with you, understanding your unique business objectives and challenges, to develop strategies that align with your vision.</Text>
                </div>
                </>
              </SplitContent>
              </>
            </ContentArea>

          <Contact />
        </main>
      </PageTransition>
    </>
  )
}
